// extracted by mini-css-extract-plugin
export var divider = "_3s-0";
export var dividerText = "_3s-1";